import { call, put, select, takeLatest } from "redux-saga/effects";
import { FETCH_GROWTH_OPRTUNITY_ACC_CLEINT_REQUEST, fetchGrowthOppurtunityByAccNclientFailure, fetchGrowthOppurtunityByAccNclientSuccess } from "../actions/growthOpportunitiesByAccountAndClientActions";
import { fetchGrowthOpportunitiesByAccountAndClient } from "../../../services/accIqService";


// Worker Saga
function* fetchGrowthOpportunitiesByAccountAndClientSaga() {
  try {
    const payload = yield select(state=>state?.growthOpportunitiesByAccountAndClientReducer?.payload);
    const {accountId, accountName, clientName} = payload
    const data = yield call(fetchGrowthOpportunitiesByAccountAndClient,accountId, accountName, clientName);
    yield put(fetchGrowthOppurtunityByAccNclientSuccess(data));
  } catch (error) {
    yield put(fetchGrowthOppurtunityByAccNclientFailure(error.message));
  }
}

// Watcher Saga
export function* watchFetchGrowthOpportunitiesByAccountAndClient() {
  yield takeLatest(FETCH_GROWTH_OPRTUNITY_ACC_CLEINT_REQUEST, fetchGrowthOpportunitiesByAccountAndClientSaga);
}
